import { FiShare2 } from "react-icons/fi";
import api from "../utils/api";

export default function ShareButton({
  type = "video",      // video | short | post
  id,                  // videoId / shortId / postId
  shareCount = 0,
  size = 16,
}) {
  const share = async () => {
    const url = `${window.location.origin}/${type}/${id}`;

    try {
      // 1?? Native share (mobile + supported browsers)
      if (navigator.share) {
        await navigator.share({
          title: "Check this out",
          url,
        });
      } else {
        // 2?? Fallback: copy link
        await navigator.clipboard.writeText(url);
        alert("Link copied!");
      }

      // 3?? Backend share count (guest allowed)
      await api.post("/client/share/create", {
        type,
        refId: id,
      });

    } catch (err) {
      console.error("Share failed", err);
    }
  };

  return (
    <span
      onClick={share}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
      }}
    >
      <FiShare2 size={size} />
      {shareCount}
    </span>
  );
}
